



















import {Component, Prop, Vue} from "vue-property-decorator";
import MediaGridRow from "@share/web-conferences/components/media-library/media-table/MediaGridRow.vue";
import MediaGridHeader from "@share/web-conferences/components/media-library/media-table/MediaGridHeader.vue";
import {WebConferencesSlides} from "@api/models/WebСonferencesSlides";
import {MediaGridSorting} from "@share/web-conferences/types/media/MediaGridSorting";
import {CurrentPresentation} from "@api/models/interfaces/web-conference/CurrentPresentation";
import {SharingTypes} from "@api/enums/WebConferenceSlides/SharingTypes";
import {WebConferenceService} from "@share/web-conferences/data/WebConferenceService";
import {NoticeLevel} from "@service/components/toast/type/Enums";
import SearchInput from "@share/common/search-input/SearchInput.vue";
import {showWarningThatSomeoneIsAlreadySharing} from "@share/web-conferences/helpers/media/NotificationsHelper";

@Component({
    name: "MediaGrid",
    components: {SearchInput, MediaGridHeader, MediaGridRow}
})
export default class MediaGrid extends Vue {
    @Prop() list: WebConferencesSlides[];
    @Prop() webConferenceService: WebConferenceService;

    beingChosenId = '';
    search = '';

    fieldsNameMap: Record<string, string> = {
        'date added': 'updatedAt',
        'filename': 'originFileName'
    }

    sortableFields = ['filename', 'date added'];

    sorting: MediaGridSorting = {
        fieldName: 'date added',
        direction: 'desc'
    }

    get userId() {
        return this.$store.state.session.userId;
    }

    get sortedList() {
        let sortedList = this.list.sort((a, b) => {
            const fieldName = this.fieldsNameMap[this.sorting.fieldName];
            const valueA = a[fieldName];
            const valueB = b[fieldName];

            if (valueA < valueB) {
                return this.sorting.direction == 'asc' ? -1 : 1;
            }
            if (valueA > valueB) {
                return this.sorting.direction == 'asc' ? 1 : -1;
            }

            return 0;
        });

        if (this.search) {
            const parts = this.search
                .trim()
                .split(' ')
                .map(item => item.trim().toLocaleLowerCase())
                .filter(item => item)
                .map(item => `(?=.*${item})`);

            const regexp = new RegExp(parts.join(''));
            sortedList = sortedList.filter(item => regexp.test(item.originFileName.toLocaleLowerCase()));
        }

        return sortedList;
    }

    onChangeSort(header: string) {
        if (this.sorting.fieldName == header) {
            this.sorting = {
                ...this.sorting,
                direction: this.sorting.direction == 'asc' ? 'desc' : 'asc'
            };
        }
        else {
            this.sorting = {
                fieldName: header,
                direction: 'asc'
            };
        }
    }

    async onChoose(file: WebConferencesSlides) {
        if (this.webConferenceService.webConferenceData?.isSharing()) {
            showWarningThatSomeoneIsAlreadySharing(this.$store);
            return;
        }

        this.beingChosenId = file.id;

        const changeResult = await this.webConferenceService.changeCurrentPresentation({
            type: SharingTypes.Slides,
            userId: this.userId,
            data: {
                slidesId: file.id,
                currentSlideFileId: file.fileIds[0]
            }
        } as CurrentPresentation);

        if (changeResult) {
            this.$emit('chosen');
        }
        else {
            this.$store.dispatch('notice/submitNotice', {
                text: this.$t('web-conferences.media-library.errors.failedToChoose'),
                level: NoticeLevel.danger
            })
        }

        this.beingChosenId = '';
    }
}
